import * as React from "react";
import IconBase from "./IconBase";

function IconSettingsSharp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.8 2.8a1.3 1.3 0 0 1 1.3-1.1h1.8a1.3 1.3 0 0 1 1.3 1.1l.3 1.8c.7.3 1.4.7 2 1.1l1.7-.6a1.3 1.3 0 0 1 1.6.6l.9 1.6a1.3 1.3 0 0 1-.3 1.7L19 10.2a8 8 0 0 1 0 2.4l1.4 1.2c.5.4.6 1.1.3 1.7l-.9 1.6c-.3.6-1 .8-1.6.6l-1.7-.6c-.6.5-1.3.8-2 1.1l-.3 1.8a1.3 1.3 0 0 1-1.3 1.1h-1.8A1.3 1.3 0 0 1 9.8 20l-.3-1.8c-.7-.3-1.4-.7-2-1.1l-1.7.6a1.3 1.3 0 0 1-1.6-.6l-.9-1.6a1.3 1.3 0 0 1 .3-1.7L5 12.6a8 8 0 0 1 0-2.4L3.6 9a1.3 1.3 0 0 1-.3-1.7l.9-1.6c.3-.6 1-.8 1.6-.6l1.7.6c.6-.5 1.3-.8 2-1.1zM12 15.7a3.7 3.7 0 1 0 0-7.4 3.7 3.7 0 0 0 0 7.4"
      />
    </IconBase>
  );
}

export default IconSettingsSharp;
